const Loading = ({ message = "Loading..." }: { message?: string }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-wheat">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-wheat mb-4"></div>
      <p className="text-lg font-bold animate-pulse">{message}</p>
    </div>
  );
};

export default Loading;



